import styled from "styled-components";
import { Tooltip } from "melco-ui";

// Colors copied verbatim from the reference HTML's .sdot-ok / .sdot-warn / .sdot-error
const DOT_COLOR: Record<"success" | "warning" | "error" | "neutral", string> = {
  success: "#22c55e",
  warning: "#f59e0b",
  error: "#ef4444",
  neutral: "#c7c7c7",
};

const Dot = styled.span<{ variant: keyof typeof DOT_COLOR }>`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 3px;
  background-color: ${({ variant }) => DOT_COLOR[variant]};
`;

type StatusDotProps = {
  variant: "success" | "warning" | "error" | "neutral";
  title?: string;
};

export const StatusDot: React.FC<StatusDotProps> = ({ variant, title }) => {
  const dot = <Dot variant={variant} />;
  return title ? <Tooltip title={title}>{dot}</Tooltip> : dot;
};
